import { CircledCrossIcon } from '../Icons';
import * as React from 'react';
import { Filespace } from 'fs-api-client';
import {
    convertMongoObjectIdToDate,
    formatDataSize,
    getRegionName
} from '../../../utils/utilFunctions';

interface FilespaceDetailsModalProps {
    filespace: Filespace;
    domainName: string;
}

function getFilespaceFormat(filespaceVersion: number): string {
    switch (filespaceVersion) {
        case 1:
        case 2:
        case 3:
            return '1.0';
        case 4:
            return '2.0';
        case 6:
            return '2.2';
        default:
            return 'Invalid format';
    }

}

export const FilespaceDetailsModal = (filespaceDetails: FilespaceDetailsModalProps): JSX.Element | null => {
    const { filespace } = filespaceDetails;
    if (!filespace.name) {
        return null;
    }
    const fullFsName = filespace.name + '.' + filespaceDetails.domainName;

    return (
        <div
            className="modal fade initModal"
            id="filespaceDetailsModal"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="filespaceDetailsModal"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-lg detailsModal" role="document">
                <div className="modal-content">
                    <div className="modal-header num">
                        <h2 className="modal-title">
                            Details for
                            <strong className="wrapWord">{fullFsName}</strong>
                        </h2>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">
                                    <CircledCrossIcon width="20px" height="20px"/>
                                </span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <ul>
                            <li>
                                <span>Create date</span>
                                {convertMongoObjectIdToDate(filespace.id!).toDateString()}
                            </li>
                            <li>
                                <span>Provider</span>
                                {filespace.storage.provider}
                                &nbsp;
                                ({getRegionName(filespace.storage.provider, filespace.storage.region!)})
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <span>File system size</span>
                                {filespace.stats ? formatDataSize(filespace.stats.filespaceSize) : '0 GB'}
                            </li>
                            <li>
                                <span>Used storage</span>
                                {filespace.stats ? formatDataSize(filespace.stats.usedStorage) : '0 GB'}
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <span>Number of users</span>
                                {filespace.usersCount ? filespace.usersCount : 0}
                            </li>
                            <li>
                                <span>
                                    <a href="https://lucidlink.com/kb-filespace-formats" target="_blank">Filespace format</a>
                                </span>
                                {getFilespaceFormat(filespace.version!)}
                            </li>
                        </ul>

                    </div>
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/webportal/components/common/modals/FilespaceDetailsModal.tsx